import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from 'swiper';
import "swiper/css";
import 'swiper/css/pagination';
/* 개발담당:이재호
 * 화면기능:배너광고
 * 세부설명:
*/

export class BannerAd extends Component {
    static displayName = BannerAd.name;

    constructor(props) {

        super(props);
        this.state = {
            HomeBannerList: [],
            HomeCBannerList: [],
            BasketBannerList: [],
            GoodsDtlBannerList: [],
            OrderStoreBannerList: []
        };
        this.Ads_loc_cd = Big3Common.Util.GetContentState(this.props, "ads_loc_cd", "");
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    async componentDidMount() {
        await this.GetHomeBanner();

        if (this.Ads_loc_cd === "BS") {
            await this.GetBasketBanner();
        }
        else if (this.Ads_loc_cd === "GD") {
            await this.GetGoodsDtlBanner();
        }
        else if (this.Ads_loc_cd === "OS") {
            await this.GetOrderStoreBanner(); 
        }
    }
    //배너 리스트 가져오기
    async GetHomeBanner() {
        try {
            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/AdMgr/BannerAd/GetHomeBanner', { uid_type: this.Uid_Type });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const HomeBannerList = DataList.HomeBannerList;
                const HomeCBannerList = DataList.HomeCBannerList;

                this.setState({
                    HomeBannerList: HomeBannerList,
                    HomeCBannerList: HomeCBannerList,
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetHomeBanner", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    async GetBasketBanner() {
        try {
            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/AdMgr/BannerAd/GetBasketBanner', { uid_type: this.Uid_Type });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const BasketBannerList = JSON.parse(Data.dataTable);
                this.setState({
                    BasketBannerList: BasketBannerList,
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetBasketBanner", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    async GetGoodsDtlBanner() {
        try {
            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/AdMgr/BannerAd/GetGoodsDtlBanner', { uid_type: this.Uid_Type });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const GoodsDtlBannerList = JSON.parse(Data.dataTable);
                this.setState({
                    GoodsDtlBannerList: GoodsDtlBannerList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetGoodsDtlBanner", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    async GetOrderStoreBanner() {
        try {
            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/AdMgr/BannerAd/GetOrderStoreBanner', { uid_type: this.Uid_Type });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const OrderStoreBannerList = JSON.parse(Data.dataTable);
                this.setState({
                    OrderStoreBannerList: OrderStoreBannerList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetOrderStoreBanner", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //배너 클릭시 링크url로 전환
    handle_Location = (event, link_url) => {
        window.open(link_url, "_blank");
        event.preventDefault();
    }
    Bannerrender(BannerList, BannerType) {
        const VirtualRoot = Big3Common.WebConfig.EventImageVirtualPath();

        if (BannerList === null) {
            return null
        }
        if (BannerList.length === 0) {
            return null
        }

        if (BannerType === "SB") {
            return (
                <>
                    <Swiper className="main_banner" watchSlidesProgress={true} slidesPerView='1' autoplay={{ delay: 2000 }} modules={[Autoplay, Pagination]}>
                        {
                            BannerList.map((list, idx) => (
                                <div key={list.ads_detail_id}>
                                    <SwiperSlide key={list.ads_detail_id}>
                                        {list.link_type_cd === "OL" ?
                                            <img src={`${VirtualRoot}/${list.file_path}`} alt="" onClick={(e) => { this.handle_Location(e, list.link_url) }} />
                                            :
                                            <Link to={list.link_url}>
                                                <img src={`${VirtualRoot}/${list.file_path}`} alt="" />
                                            </Link>
                                        }
                                        {/*<div className="banner_page_number">
                                            <div>{idx + 1}</div>
                                            <div>/</div>
                                            <div>{BannerList.length}</div>
                                        </div>*/}
                                    </SwiperSlide>
                                </div>
                            ))
                        }
                    </Swiper>
                </>
            )
        } else if (BannerType === "CB") {
            return (
                <div>
                    {BannerList.map((list) => (
                        <div className="main_banner" key={list.ads_detail_id}>
                            {list.linkType === "OL" ?
                                <img src={`${VirtualRoot}/${list.file_path}`} alt="" onClick={(e) => { this.handle_Location(e, list.link_url) }} />
                                :
                                <Link to={list.link_url}>
                                    <img src={`${VirtualRoot}/${list.file_path}`} alt="" />
                                </Link>
                            }
                        </div>
                    ))}
                </div>
            )
        } else {
            return null;
        }
    }
    render() {

        switch (this.Ads_loc_cd) {
            case "H1":
                return this.Bannerrender(this.state.HomeBannerList, "SB");
            case "H2":
                return this.Bannerrender(this.state.HomeCBannerList, "CB");
            case "BS":
                return this.Bannerrender(this.state.BasketBannerList, "SB");
            case "GD":
                return this.Bannerrender(this.state.GoodsDtlBannerList, "SB");
            case "OS":
                return this.Bannerrender(this.state.OrderStoreBannerList, "SB");
            default:
                break;
        }

    }
}
